import { render, staticRenderFns } from "./ObjectStateTag.vue?vue&type=template&id=fac93f0a&scoped=true&"
import script from "./ObjectStateTag.vue?vue&type=script&lang=ts&"
export * from "./ObjectStateTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac93f0a",
  null
  
)

export default component.exports